import React, { useState, useEffect } from "react";
// import { SerialPortOpenOptions, SerialPortMock, SerialPort } from "serialport";
function Help(){
    const questions=[
        {
            question: "Can I make alert on other device when I reached marked geodesics?",
            answer: `Yes, with your account you have the privilege to alert other devices too. But this feature will not be provided in the Voyager. You have to go for Voyager client which may available from the store. don't download Voyager(or voyager client) from third party sites which may be a malware. The software availability will be based on play regularization.`
        },
        {
            question: "Does it turn on my apartment light when I reached?",
            answer: `Voyager have the ability to transmit the switch states from the initial version of application. The secure transmission for the micro controller(to control connected devices) is in progress. When it is available you can do all related operations from this site.`
        },
        {
            question: "How to use Voyager application?",
            answer: `Login to the application with google signin. → Long press on the target location where you are navigating to. → Add a marker on the target location by submitting with name(required to identify which marker), memories with that location(for the longtime location identification), check 'Permanent marker' if you want it to be permanent marker. → Now click on the marker to pick target range, then select range and submit it by clicking on 'okay'. → Before navigation, ensure location is turned on in floating button.`
        },
        {
            question: "Support for other devices than android?",
            answer: `No support for other platforms like iOS. However it will be available to tizen, ESP-8266(MCU).`
        },
        {
            question: "Any pro features that the app have?",
            answer: `Voyager doesn't have any ad services. All services binded with this app if free to use`
        },
        {
            question: "Why does this app requires account?",
            answer: `Voyager stores switch(electronic switch based on relays) states in online based on user's UUID. This UUID is unique and globally accessible from your account. So the application data will be persisted even you are uninstalled this application.`
        },
        {
            question: "What are the informations you will collect from this app?",
            answer: `Email ID(to create account), and location(for app's functionality). However your location data will not be shared in online to secure user's information.`
        },
        {
            question: "Am I safe in this App?",
            answer: `Yes, you are completely safe.`
        }
    ];
    const [soc,setSoc ]=useState(new WebSocket("ws:localhost:3000"))
    useEffect(() => {
        soc.onopen=function(){
            soc.send("hello world");
        }
      return () => {
        soc.close();
      }
    }, [])
    
    const [expanded, setExpanded]=useState(-1);
    
    return(
        <div className="container" >
            <h1>Help & Support</h1>
            {questions.map((qobj, i)=>
            <React.Fragment key={i} >
            <button onClick={()=>{setExpanded(e=>e===i?-1:i)}} className="qa-question btn qa-btn">{qobj.question}</button>
            <div className={`qa-answer ${expanded===i? "expanded":""}`}>{qobj.answer}</div>
            </React.Fragment>
            )}
        </div>
    );
}

export default Help;